import React from "react";
import {
  ClipboardList, Smartphone, Thermometer, SprayCan, Wrench, AlertTriangle,
  History, FolderOpen, Gavel, Building2, Users, FileBarChart, RefreshCw,
} from "lucide-react";

const features = [
  { title: "Digital HACCP management", icon: ClipboardList, desc: "Build and maintain the HACCP system online, with every control point recorded." },
  { title: "Mobile food-safety inspections", icon: Smartphone, desc: "Inspections completed on the kitchen floor, not typed up later." },
  { title: "Temperature monitoring", icon: Thermometer, desc: "Fridge, freezer, cooking, cooling and hot-holding records in one place." },
  { title: "Cleaning and hygiene checks", icon: SprayCan, desc: "Opening, closing and cleaning routines with timestamps." },
  { title: "Corrective actions", icon: Wrench, desc: "Out-of-range readings raise an action that has to be closed." },
  { title: "Incident reporting", icon: AlertTriangle, desc: "Log incidents with detail, photos and follow-up." },
  { title: "Compliance history", icon: History, desc: "A dated record of what was checked, by whom, and what happened next." },
  { title: "Document management", icon: FolderOpen, desc: "Store HACCP plans, policies, schedules and procedures alongside the records." },
  { title: "Regional law packs", icon: Gavel, desc: "Region-specific requirements applied to each business or location." },
  { title: "Multi-location management", icon: Building2, desc: "Every site visible from one dashboard." },
  { title: "Staff roles and permissions", icon: Users, desc: "People see the work that belongs to them." },
  { title: "Reports and inspection preparation", icon: FileBarChart, desc: "Export the evidence an inspector asks for." },
  { title: "Web and mobile synchronisation", icon: RefreshCw, desc: "Activity recorded in the app appears in the dashboard." },
];

export default function PlatformFeatures() {
  return (
    <section id="features" className="relative">
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24">
        <h2 className="heading-app text-3xl md:text-4xl mb-8 text-center">
          What the platform does
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map(({ title, icon: Icon, desc }) => (
            <div key={title} className="app-card p-5">
              <div className="p-2.5 rounded-xl bg-crystal-orange/20 border border-crystal-orange/40 w-fit mb-3">
                <Icon className="h-5 w-5 text-crystal-orange" />
              </div>
              <div className="text-white font-semibold">{title}</div>
              <p className="text-white/65 text-sm mt-1.5">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
